import React from 'react';
import { motion } from 'framer-motion';
import { FaShieldAlt, FaLock, FaCheckCircle, FaFileContract } from 'react-icons/fa';

const trustFeatures = [
  { id: "hipaa", icon: <FaShieldAlt />, text: "HIPAA-compliant infrastructure" },
  { id: "baa", icon: <FaFileContract />, text: "Business Associate Agreement signed before go-live" },
  { id: "aes", icon: <FaLock />, text: "AES-256 encryption (same as banks)" },
  { id: "tls", icon: <FaCheckCircle />, text: "TLS 1.2+ in transit" },
  { id: "vendors", icon: <FaCheckCircle />, text: "Vendors selected for strong security and compliance practices" },
  { id: "audit", icon: <FaCheckCircle />, text: "Audit logs on all PHI access" },
  { id: "docs", icon: <FaCheckCircle />, text: "Full HIPAA documentation provided at onboarding" },
  { id: "reports", icon: <FaCheckCircle />, text: "Compliance audit reports available on request" }
];

const TrustSection = () => {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 relative bg-slate-900/50" id="trust">
      <div className="relative z-10 max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Built for PI. <span className="gradient-text">Compliant from Day One.</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            HIPAA compliance isn't optional when you're handling Protected Health Information. We've got you covered.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
          {trustFeatures.map((feature, index) => (
            <motion.div
              key={feature.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.05 }}
              className="bg-slate-800/70 backdrop-blur-sm border border-slate-700 rounded-xl p-6 hover-lift"
              data-testid={`trust-feature-${index}`}
            >
              <div className="flex items-center">
                <div className="text-3xl text-emerald-400 mr-4">{feature.icon}</div>
                <span className="text-gray-300 font-semibold">{feature.text}</span>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Bottom emphasis */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="text-center"
        >
          <div className="bg-gradient-to-r from-emerald-500/10 to-emerald-600/10 border border-emerald-500/30 rounded-2xl p-8 max-w-4xl mx-auto">
            <h3 className="text-2xl font-bold mb-4 text-white">
              Built to Minimize Risk. Full Protection.
            </h3>
            <p className="text-lg text-gray-300 mb-4">
              We partner with leading HIPAA-compliant vendors including GoHighLevel, Cognito Forms, Karagon, and Retell AI - all of whom sign Business Associate Agreements. We sign one with you too.
            </p>
            <p className="text-lg text-gray-300">
              Your PHI is encrypted at rest and in transit. Full compliance documentation and audit reports provided on request.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default TrustSection;
